export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const GET_ERRORS = "GET_ERRORS";
export const CREATE_MESSAGE = "CREATE_MESSAGE";
//
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const VERIFY_SUCCESS = "VERIFY_SUCCESS";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const USER_IMAGE_SUCCESS = "USER_IMAGE_SUCCESS";
export const USER_IMAGE_BASE_URL_SUCCESS = "USER_IMAGE_BASE_URL_SUCCESS";
//
export const USER_EMAIL_SUCCESS = "USER_EMAIL_SUCCESS";
export const CHANGE_USER_PASSWORD_SUCCESS = "CHANGE_USER_PASSWORD_SUCCESS";
export const GET_USERS = "GET_USERS";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const LOADING_USERS = "LOADING_USERS";
export const GET_VERTCALS = "GET_VERTICALS";
export const CREATE_MERCHANT = "CREATE_MERCHANT";
export const CREATE_VERTICAL = "CREATE_VERTICAL";
export const GET_VERTICALS = "GET_VERTICALS";
export const LOADING_VERTICALS = "LOADING_VERTICALS";
export const GET_MERCHANTS = "GET_MERCHANTS";
export const ADD_CARTEGORY = "ADD_CARTEGORY";
//
export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
//
export const GET_CATEGORIES = "GET_CATEGORIES";
export const EDIT_CATEGORY = "EDIT_CATEGORY";
//
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const EDIT_QTY = "EDIT_QTY";
export const GET_CURRENT_ITEM = "GET_CURRENT_ITEM";
export const SET_TOTAL_PRICE = "SET_TOTAL_PRICE";
//
export const ADD_USER_CONTACT = "ADD_USER_CONTACT";
export const REMOVE_USER_CONTACT = "REMOVE_USER_CONTACT";
export const SET_USER_CONTACT = "SET_USER_CONTACT";
export const GET_USER_CONTACT = "GET_USER_CONTACT";

//GENERAL FILTERS
export const FILTER_BY_PRICE = "FILTER_BY_PRICE";
export const FILTER_BY_RATING = "FILTER_BY_RATING";
export const FILTER_BY_BRAND = "FILTER_BY_BRAND";
export const FILTER_BY_COLOR = "FILTER_BY_COLOR";
export const FILTER_BY_SHIPPED_FROM = "FILTER_BY_SHIPPED_FROM";
export const FILTER_BY_SELLER_SCORE = "FILTER_BY_SELLER_SCORE";
export const FILTER_BY_DISCOUNT_PERCENTAGE = "FILTER_BY_DISCOUNT_PERCENTAGE";

//PHONENTABLET FILTERS
export const FILTER_BY_OPERATING_SYSTEM = "FILTER_BY_OPERATING_SYSTEM";
export const FILTER_BY_HARD_DISK = "FILTER_BY_HARD_DISK";
export const FILTER_BY_RAM = "FILTER_BY_RAM";
export const FILTER_BY_MEGAPIXELS = "FILTER_BY_MEGAPIXELS";
export const FILTER_BY_OPTICAL_ZOOM= "FILTER_BY_OPTICAL_ZOOM";
export const FILTER_BY_SCREEN_SIZE = "FILTER_BY_SCREEN_SIZE";
